import React from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import {motion} from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import ComparisonPage from './pages/ComparisonPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ThankYouPage from './pages/ThankYouPage';
import CityLandingPage from './pages/CityLandingPage';
import SubCityLandingPage from './pages/SubCityLandingPage';
import QuotePage from './pages/QuotePage';
import SEOHead from './components/SEOHead';

import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <SEOHead />
          <Header />
          <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/compare" element={<ComparisonPage />} />
              <Route path="/quote" element={<QuotePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              {/* City and SubCity Routes */}
              <Route path="/pet-insurance/:citySlug" element={<CityLandingPage />} />
              <Route
                path="/pet-insurance/:citySlug/:subCitySlug"
                element={<SubCityLandingPage />}
              />
            </Routes>
          </motion.main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;